import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { LeaveTypeApiItem } from "@/actions/ssr/settings/getLeaveTypesSSR";

interface LeaveTypeState {
  items: LeaveTypeApiItem[];
  totalPages: number;
  currentPage: number;
  totalItems: number;
}

const initialState: LeaveTypeState = {
  items: [],
  totalPages: 1,
  currentPage: 1,
  totalItems: 0,
};

const leaveTypeSlice = createSlice({
  name: "leaveType",
  initialState,
  reducers: {
    setLeaveTypeItems(state, action: PayloadAction<LeaveTypeApiItem[]>) {
      state.items = action.payload;
    },
    setLeaveTypePagination(
      state,
      action: PayloadAction<{
        totalPages: number;
        currentPage: number;
        totalItems?: number;
      }>,
    ) {
      state.totalPages = action.payload.totalPages;
      state.currentPage = action.payload.currentPage;
      if (action.payload.totalItems !== undefined) {
        state.totalItems = action.payload.totalItems;
      }
    },
  },
});

export const { setLeaveTypeItems, setLeaveTypePagination } =
  leaveTypeSlice.actions;
export default leaveTypeSlice.reducer;
